<template>
  <v-card class="elevation-4 grey darken-4 chipContainer">
    <v-card-title>
      <h3 class="headline mb-0">{{title}}</h3>
      <v-dialog v-model="ChipEditorDialog" scrollable lazy absolute>
        <v-btn v-if="(!unique || resource == null) && !keepSync" slot="activator" icon class="orange--text">
          <v-icon>add_box</v-icon>
        </v-btn>
        <v-card>
          <v-card-title>
            <div class="headline">Aggiungi {{title}}</div>
          </v-card-title>
          <v-card-text>
            <v-text-field
              name="fullr-ricerca"
              label="Ricerca"
              class="noMargin"
              v-model="chipRicerca"
              autofocus
            ></v-text-field>
            <div class="chipListContainer">
              <v-list class="vlist">
                <virtual-scroller class="scroller" :items="fullResource" item-height="48">
                  <template slot-scope="props">
                    <v-list-tile :class="{'tag-selected': isSelected(props.item)}" @click.native.stop="add(props.item)" :item="props.item" :key="props.item._id">
                      <v-list-tile-content>
                        <v-list-tile-title>{{getDescr(props.item)}}</v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </template>
                </virtual-scroller>
                <p v-if="generator == 'newTag' && !unique && (resource != null && resource.length > 0) && fullResource.length == 0 && chipRicerca != ''">Verrà creato come sottogruppo di {{ getLast() }}</p>
                <p v-if="generator == 'newTag' && !unique && (resource != null && resource.length > 0) && fullResource.length == 0 && chipRicerca == ''">{{ getLast() }} non ha sottogruppi, inserisci una descrizione per crearne uno nuovo</p>
              </v-list>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn :loading="loading" flat @click.native.stop="createNew(chipRicerca)" v-if="canAddNew" primary>Crea Nuovo</v-btn>
            <v-btn class="green--text darken-1" flat @click.native.stop="ChipEditorDialog = false">Chiudi</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-btn 
        v-if="type != 'Tag'"
        @click.native="sortChips" 
        v-tooltip:top="{ html: 'Ordinamento alfabetico' }" 
        icon>
        <v-icon>sort_by_alpha</v-icon>
      </v-btn>
      <v-btn
        v-if="frommenu || !keepSync"
        :class="{ 'red--text': editMode }"
        @click.native="editMode = !editMode" 
        v-tooltip:top="{ html: 'Modalità elimina' }"
        icon>
        <v-icon>delete</v-icon>
      </v-btn>
      <v-btn
        v-if="frommenu"
        class="ml-auto"
        v-tooltip:top="{ html: 'Replica varianti in tutti prodotti del gruppo' }"
        flat
        @click.native="onCloneVariants"
      >
        <v-icon class="mr-2">done_all</v-icon>  
        Replica varianti in tutto il gruppo
      </v-btn>
    </v-card-title>

    <v-card-text>
      <draggable :value='computedResource' @end="onSortEnd" :options="{chosenClass: 'sortable-chosen', disabled: !(type != 'Tag' && (frommenu || !keepSync))}">
        <v-chip 
          :close="editMode"
          @input="add(r)"
          label
          :key="i"
          outline v-for="(r, i) in convert(resource)"
          class="orange orange--text">
            {{getDescr(r)}}
        </v-chip>
      </draggable>
    </v-card-text>

  </v-card>
</template>

<script>
/**
 * Modifica tag/varianti/ingredienti di un oggetto
 * @module components/common/ChipEditor
 */
  import draggable from 'vuedraggable'
  export default {
    name: 'chipEditor',
    components: { draggable },
    data: function () {
      return {
        ChipEditorDialog: false,
        chipRicerca: '',
        editMode: false
      }
    },
    /** 
     * @prop resource {array} - I tag / Varianti / Ingredienti
     * @prop type {string} - Nome del getter di riferimento
     * @prop title {string} - 
     * @prop callback {function} - Funzione chiamata dopo la modifica
     * @prop generator {string} - Nome della funzione per creare una nuova istanza dell'oggetto
     * @prop unique {boolean} - Se vero accetta un solo elemento
     * @prop listino {string} - Il listino di riferimento
     * @prop keepSync {boolean} - Se vero è readonly
     * @prop filter {array} - Filtra i valori tra cui scegliere i tag in base a quelli già inseriti
     */
    props: ['resource', 'type', 'title', 'callback', 'generator', 'unique', 'listino', 'keepSync', 'filter', 'frommenu'],
    methods: {
      getDescr (item) {
        return utils.getMainDesc(item)
      },
      convert (r) {
        let p;
        if(!this.unique)
          p = r.map(cR => this.$store.getters[this.type].find(ccR => ccR._id == cR))
        else {
          let padre = this.$store.getters[this.type].find(ccR => ccR._id == r)
          p = padre ? [padre] : []
        }
        return p
      },
      add (r) {
        this.callback(r._id, this.unique)
      },
      isSelected (tag) {
        if(!this.unique)
          return this.resource.indexOf(tag._id) != -1
        else
          return this.resource == tag._id
      },
      createNew (chipDescr) {

        if (this.type == 'Tag') {
          this.chipRicerca = ''
          let newTag = new utils.tagTpl(chipDescr.toUpperCase())[this.generator]()
          if(!this.unique)
            newTag.padre = this.resource[this.resource.length-1] || null
          this.$store.dispatch('UPDATETAG', {tag: newTag, img: null, callback: () => {}})
        } else {
          let newObj = new utils.prodTpl(chipDescr.toUpperCase(), this.listino)[this.generator]()
          newObj.tags = this.filter
          this.$store.dispatch('UPDATEPVI', {pvi: newObj, img: null, callback: () => {}})
        }
        
      },
      getLast () {
        return this.getDescr(this.$store.getters[this.type].find(item => item._id == this.resource[this.resource.length-1]))
      },
      onSortEnd ({newIndex, oldIndex}) {
        this.$emit('sorted', { newIndex, oldIndex })
      },
      sortChips() {
        const list = _(this.resource
          .map(cR => this.$store.getters[this.type].find(ccR => ccR._id == cR)))
          .sortBy([(o) => utils.getMainDesc(o).toLowerCase()])
          .map(o => o._id)
          .value();
        this.$emit('order', list);
      },
      onCloneVariants() {
        this.$emit('cloneVariants')
      },
    },
    watch: {
      ChipEditorDialog (newV) {
        if(!newV)
          this.chipRicerca = ''
      }
    },
    computed: {
      fullResource () {
        return _.chain(this.$store.getters[this.type])
          .filter((item) => {

            if(this.generator == 'newTag'){

              if(this.unique)
                return true

              let lastTag = this.resource[this.resource.length-1] || null;

              return item.padre == lastTag

            }

            let cond;

            if(this.generator == 'newVarIngr')
              cond = utils.isVariante(item) || utils.isIngrediente(item)

            return cond && 
                   (item.tags.length == 0 ||
                   item.tags.some(tag => (this.filter || []).includes(tag))) &&
                   utils.getMainDesc(item)
                    .toLowerCase()
                    .indexOf(this.chipRicerca.toLowerCase()) != -1
          })
          .sortBy((item) => utils.getMainDesc(item)).value()
      
      },
      computedResource () {
        if (Array.isArray(this.resource)) {
          return this.resource
        } else {
          return [ this.resource ]
        } 
      },
      loading () {
        return this.$store.getters.loading
      },
      canAddNew () {
        return this.fullResource.length == 0 && 
               this.chipRicerca != '' &&
               this.type == 'Tag'
      }
    }
  }
</script>

<style lang="stylus">
.chipContainer
  margin-bottom: 10px
  .chip
    transition none
    cursor pointer
.chipListContainer
  overflow-y: auto
  max-height: 300px
.sortable-chosen
  opacity: .5
</style>



// WEBPACK FOOTER //
// src/components/common/ChipEditor.vue